export const validateInvestors = value => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  if (Array.isArray(value) && value.length > 50) {
    return 'You cannot select more than 50 Investors.';
  }
  return undefined;
};

export const validateFunds = value => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Fund must be selected';
  }
  return undefined;
};

export const referenceArrayInputProps = (isRegular, creation) => {
  if (isRegular) {
    return {
      label: creation
        ? 'Select one or more Investors, so you can assign permission groups in the next step.'
        : 'To add Investor, select one or multiple items from the list of the Investors below.',
      optionTextLabel: 'Investor Name',
      optionValueLabel: 'Investor ID',
      resource: 'investors',
      reference: 'investors',
      source: 'investors',
      validate: [validateInvestors],
      perPage: -1,
      sort: { field: 'name', order: 'ASC' },
      queryfilter: { orphanVisibility: 'NON_ORPHANS_ONLY' },
      additionalColumns: [
        { label: 'Status', name: 'status', isStatusColumn: true }
      ]
    };
  } else {
    return {
      label: creation
        ? 'Select one or more Funds, so you can assign permission groups in the next step.'
        : 'To add Fund, select one or multiple items from the list of the Funds below.',
      optionTextLabel: 'Fund Name',
      optionValueLabel: 'Fund ID',
      resource: 'funds',
      reference: 'funds',
      source: 'funds',
      validate: [validateFunds],
      perPage: -1,
      sort: { field: 'name', order: 'ASC' },
      additionalColumns: [
        { label: 'Status', name: 'status', isStatusColumn: true },
        { label: 'Fund Family', name: 'fundFamilyName' }
      ]
    };
  }
};

export const getFundFamiliesIds = (fundSelected, arrayToFill) => {
  fundSelected.forEach(item => {
    if (item.fundFamilyId && !arrayToFill.includes(item.fundFamilyId)) {
      arrayToFill.push(item.fundFamilyId);
    }
  });
};
